import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import * as React from "react"
import * as Model from "../../../model"
import PriorityFilter from "../../priority-filter"

export default class PpiActions extends React.Component<Props> {
    render() {
        return <div className="ppi-actions">
            {this.renderLeftActions()}
            {this.renderRightActions()}
        </div>
    }

    private handleProjectInducedGrantClick() {
        const params: ProjectInducedGrantParams = {project: this.props.project}
        this.props.onCustomAction("project_induced_grant", params)
    }

    private handleProjectSettingsClick() {
        const params: AlterProjectActionParams = {
            project: this.props.project,
            subtheme: this.props.subtheme,
            theme: this.props.theme
        }
        this.props.onCustomAction("popup_alter_project", params)
    }

    private renderLeftActions(): React.ReactNode {
        return <div className="ppi-actions-left">
            {this.props.isProject
                ? <button
                    className="back-to-ppi"
                    title="Retourner au PPI"
                    onClick={this.props.onBack}>
                    <FontAwesomeIcon icon="backward"/>
                </button>
                : <PriorityFilter selectedPriorities={this.props.selectedPriorities}
                                  setSelectedPriorities={this.props.setSelectedPriorities}
                                  onPrioritiesChange={this.props.onPrioritiesChange} pageTitle={this.props.pageTitle}/>}

            {this.props.enablePreviousYear &&
                <label className="ppi-action-check">
                    <input
                        type="checkbox"
                        checked={this.props.previousYear}
                        onClick={() => this.props.onTogglePreviousYear()}/>
                    Afficher l'année N-1
                </label>}
        </div>
    }

    private renderRightActions(): React.ReactNode {
        return <div className="ppi-actions-right">
            {this.props.isProject &&
                [
                    <button
                        className="button btn-default"
                        key="alter-project"
                        title="Configurer le projet"
                        onClick={() => this.handleProjectSettingsClick()}>
                        <FontAwesomeIcon icon="cog"/>
                    </button>,
                    <button
                        className="button btn-default"
                        key="project-induceds"
                        title="Charges &amp; Recettes induites"
                        onClick={() => this.handleProjectInducedGrantClick()}>
                        <FontAwesomeIcon icon="list-ul"/>
                    </button>
                ]}

            {!this.props.isProject &&
                <button
                    className="button btn-default"
                    title="Affichage responsable thématique"
                    onClick={this.props.onToggleAsResponsible}>
                    <FontAwesomeIcon icon="asterisk"/>
                </button>}

            {!this.props.consulted &&
                [
                    <button
                        className="button btn-default"
                        key={0}
                        title="Supprimer la dernière année"
                        onClick={() => this.props.onCustomAction("delete_last_year")}>
                        <FontAwesomeIcon icon="minus"/>
                    </button>,
                    <button
                        className="button btn-default"
                        key={1}
                        title="Ajouter une année"
                        onClick={() => {
                            this.props.onCustomAction("add_year")
                        }}>
                        <FontAwesomeIcon icon="plus"/>
                    </button>
                ]}
        </div>
    }
}

interface Props {
    pageTitle: string;
    selectedPriorities: number[];
    consulted: boolean;
    enablePreviousYear: boolean;
    isProject: boolean;
    previousYear: boolean;
    priorities: number[];
    project: Model.PpiInvestmentProject;
    subtheme: Model.PpiInvestmentTheme;
    theme: Model.PpiInvestmentTheme;

    onBack(): void;

    onCustomAction(action: "add_year"): void;

    onCustomAction(
        action: "popup_alter_project",
        params: AlterProjectActionParams
    ): void;

    onCustomAction(
        action: "project_induced_grant",
        params: ProjectInducedGrantParams
    ): void;

    onCustomAction(action: "delete_last_year"): void;

    onPrioritiesChange(priorities: number[]): void;

    onToggleAsResponsible(): void;

    onTogglePreviousYear(): void;

    setSelectedPriorities(): void;
}

interface AlterProjectActionParams {
    project: Model.PpiInvestmentProject;
    subtheme: Model.PpiInvestmentTheme;
    theme: Model.PpiInvestmentTheme;
}

interface ProjectInducedGrantParams {
    project: Model.PpiInvestmentProject;
}



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/ppi-actions.tsx